import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import {topBannersHasLimit} from "../@signals";
import { topBannersIsEmpty } from "../@signals";


export default function useTopBannersFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${BACKEND_APIS.BANNERS}/top-banners/wrapped/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res.data?.length)
                        topBannersIsEmpty.value = true
                    data.value = res.data
                    topBannersHasLimit.value = res.hasLimit
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value
    }
}